import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Connected() {
  const navigate = useNavigate();
  const [status, setStatus] = useState('connecting');

  useEffect(() => {
    // Extract token and instance from URL
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const instance = params.get('instance');

    if (token && instance) {
      // Save to localStorage for later use
      localStorage.setItem('sf_token', token);
      localStorage.setItem('sf_instance', instance);
      setStatus('success');

      // Redirect to home after 2 seconds
      setTimeout(() => navigate('/'), 2000);
    } else {
      setStatus('error');
    }
  }, [navigate]);

  return (
    <div className="app">
      <nav className="navbar">
        <div className="logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
          SF<span>Rank</span>
        </div>
      </nav>

      <div className="hero">
        {status === 'connecting' && (
          <>
            <h1>⏳ Connecting...</h1>
            <p style={{ color: '#aaaaaa' }}>Setting up your Salesforce org</p>
          </>
        )}
        {status === 'success' && (
          <>
            <h1 style={{ color: '#00b894' }}>✅ Org Connected!</h1>
            <p style={{ color: '#aaaaaa' }}>Your Salesforce org is connected. Redirecting you back...</p>
          </>
        )}
        {status === 'error' && (
          <>
            <h1 style={{ color: '#e74c3c' }}>❌ Connection Failed</h1>
            <p style={{ color: '#aaaaaa' }}>Something went wrong. Please try again.</p>
            <button className="btn-connect" onClick={() => navigate('/')}>
              Go Home
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default Connected;